import { render, staticRenderFns } from "./OrgInfo.vue?vue&type=template&id=33f8870d&scoped=true"
import script from "./OrgInfo.vue?vue&type=script&lang=js"
export * from "./OrgInfo.vue?vue&type=script&lang=js"
import style0 from "./OrgInfo.vue?vue&type=style&index=0&id=33f8870d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8870d",
  null
  
)

export default component.exports